import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=6d0705f4"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"
import style0 from "./mainPage.vue?vue&type=style&index=0&id=6d0705f4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports